
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Bell, Settings } from "lucide-react";
import { MobileNavigation } from "./MobileNavigation";
import { useAuth } from "@/context/AuthContext";

export const MobileDashboardHeader = () => {
  const { user } = useAuth();

  return (
    <div className="md:hidden fixed top-0 left-0 right-0 z-50 glass-card border-b border-border/50">
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex items-center space-x-3">
          <MobileNavigation />
          <h1 className="text-lg font-heading font-bold text-gradient">Noche Loco</h1>
        </div>
        
        <div className="flex items-center space-x-2">
          <Button variant="ghost" size="sm" className="text-foreground hover:text-primary">
            <Bell className="h-5 w-5" />
          </Button>
          <Button variant="ghost" size="sm" className="text-foreground hover:text-primary">
            <Settings className="h-5 w-5" />
          </Button>
          <Avatar className="h-8 w-8 ring-2 ring-primary/30">
            <AvatarImage src={user?.user_metadata?.avatar_url} />
            <AvatarFallback className="bg-gradient-to-br from-primary to-secondary text-white text-xs font-semibold">
              {user?.email?.charAt(0).toUpperCase() || "U"}
            </AvatarFallback>
          </Avatar>
        </div>
      </div>
    </div>
  );
};
